module.exports = __webpack_public_path__ + "static/waterskin-e0630e9b88a12772e81d42633cb2e5a5.jpg";